module.exports = __webpack_public_path__ + "img/4-5.5780b39a.svg";